import { render } from "./articleEdit.vue?vue&type=template&id=acd5c4d6&scoped=true"
import script from "./articleEdit.vue?vue&type=script&lang=js"
export * from "./articleEdit.vue?vue&type=script&lang=js"

import "./articleEdit.vue?vue&type=style&index=0&id=acd5c4d6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd5c4d6"],['__file',"src/views/contentCenter/articleEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acd5c4d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acd5c4d6', __exports__)) {
    console.log('reload')
    api.reload('acd5c4d6', __exports__)
  }
  
  module.hot.accept("./articleEdit.vue?vue&type=template&id=acd5c4d6&scoped=true", () => {
    console.log('re-render')
    api.rerender('acd5c4d6', render)
  })

}


export default __exports__